// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26nhs","placeholdersHeader":"styles_placeholdersHeader__PeT7O","editorStyle":"styles_editorStyle__1BT_h","placeholdersBox":"styles_placeholdersBox__m2pbJ"};